import tseInstance from '../instance'

const putTseFonData = (data) => {
	return tseInstance.put('/company/tse/fon', data)
}

export default putTseFonData
